import getSubfragm from "./get-subfragm";
export default getSubfragm;
